export function getKeyFromHref(href) {
  return href.split('/').pop();
}
